import React from 'react'

function OurService() {
  return (
    <>
      <section className="service-section-app pad-tb dark-bg2">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="common-heading ptag">
                <span>Service</span>
                <h2>Our Services</h2>
                <p className="mb30">
                  We think big and have hands in all leading technology platforms to provide you
                  wide array of services.
                </p>
              </div>
            </div>
          </div>
          <div className="row upset">
            <div className="col-lg-4 col-md-6 mt30 d-flex">
              <div className="service-card-app hoshd h-100 w-100 d-flex flex-column">
                <h4>e-Governance Solutions</h4>
                <ul className="-service-list mt10">
                  <li><a href="#">.NET CORE</a></li>
                  <li><a href="#">PHP</a></li>
                  <li><a href="#">Cross Platform</a></li>
                </ul>
              
                <p className="mt20 flex-grow-1">
                  N D Techland Pvt. Ltd. crafts custom mobile apps for iOS, Android, and cross-platform, prioritizing user experience and scalability.
                </p>
                <a href="javascript:void(0)" className="mt20 link-prbs">
                  Read More <i className="fas fa fa-arrow-circle-right"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt30 d-flex">
              <div className="service-card-app hoshd h-100 w-100 d-flex flex-column">
                <h4>Software Development</h4>
                <ul className="-service-list mt10">
                  <li><a href="#">UI/UX</a></li>
                  <li><a href="#">PHP</a></li>
                  <li><a href="#">React</a></li>
                  <li><a href="#">.NET CORE</a></li>
                </ul>
               
                <p className="mt20 flex-grow-1">
                 We build tailor-made software solutions designed to meet specific business and institutional needs, ensuring efficiency, scalability, integration capability, and long-term performance.
                </p>
                <a href="javascript:void(0)" className="mt20 link-prbs">
                  Read More <i className="fas fa fa-arrow-circle-right"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt30 d-flex">
              <div className="service-card-app hoshd h-100 w-100 d-flex flex-column">
                <h4>Web Portal Development</h4>
                <ul className="-service-list mt10">
                  <li><a href="#">.net CORE</a></li>
                  <li><a href="#">Shopify</a></li>
                  <li><a href="#">php</a></li>
                </ul>
              
                <p className="mt20 flex-grow-1">
                 We create secure, responsive, and high-performance websites and portals that ensure accessibility, seamless user experience, and reliable digital presence for organizations.
                </p>
                <a href="javascript:void(0)" className="mt20 link-prbs">
                  Read More <i className="fas fa fa-arrow-circle-right"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt30 d-flex">
              <div className="service-card-app hoshd h-100 w-100 d-flex flex-column">
                <h4> Mobile App Development</h4>
                <ul className="-service-list mt10">
                  <li><a href="#">Android</a></li>
                  <li><a href="#">IOS</a></li>
                  <li><a href="#">Cross Platform</a></li>
                </ul>
              
                <p className="mt20 flex-grow-1">
                We design intuitive mobile applications that enhance citizen services, enable enterprise mobility, and improve operational efficiency through secure and user-friendly interfaces.
                </p>
                <a href="javascript:void(0)" className="mt20 link-prbs">
                  Read More <i className="fas fa fa-arrow-circle-right"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt30 d-flex">
              <div className="service-card-app hoshd h-100 w-100 d-flex flex-column">
                <h4>GIS-Based Solutions</h4>
                <ul className="-service-list mt10">
                  <li><a href="#">API</a></li>
                  <li><a href="#">.NET CORE</a></li>
                  <li><a href="#">PHP</a></li>
                </ul>
              
                <p className="mt20 flex-grow-1">
                We deliver advanced GIS-enabled platforms for mapping, monitoring, spatial analysis, and planning, enabling data-driven decisions and efficient resource management.
                </p>
                <a href="javascript:void(0)" className="mt20 link-prbs">
                  Read More <i className="fas fa fa-arrow-circle-right"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mt30 d-flex">
              <div className="service-card-app hoshd h-100 w-100 d-flex flex-column">
                <h4>ERP & Enterprise Solutions</h4>
                <ul className="-service-list mt10">
                  <li><a href="#">.NET CORE</a></li>
                  <li><a href="#">ASP .NET</a></li>
                  <li><a href="#">MVC</a></li>
                </ul>
              
                <p className="mt20 flex-grow-1">
               Our integrated ERP systems automate workflows, optimize resource management, improve operational control, and support data-driven decision-making across organizational processes.
                </p>
                <a href="javascript:void(0)" className="mt20 link-prbs">
                  Read More <i className="fas fa fa-arrow-circle-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default OurService